import "bootstrap/dist/css/bootstrap.css";
import * as React from "react";
import { createRoot } from 'react-dom/client';
import * as ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import unregister  from "./registerServiceWorker";
import  registerServiceWorker from "./registerServiceWorker";
import { GlobalContextProvider } from "./pages/shared/context/global.context";
import { AxiosInterceptor } from "./interceptors/axios.interceptor";
//import {SnackbarProvider} from "notistack"

const baseUrl = document
  .getElementsByTagName("base")[0]
  .getAttribute("href")  

AxiosInterceptor();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<BrowserRouter basename={baseUrl}>
  <GlobalContextProvider>
    {/*<SnackbarProvider>*/}
    <App />
    {/*  </SnackbarProvider>*/}
  </GlobalContextProvider>
  
</BrowserRouter>);

// registerServiceWorker();
unregister();
